
import swal from "sweetalert2";
import { computed, defineComponent, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "@/store";
import { useI18n } from "vue-i18n";
import { api } from "@/services/Api";
import { OrderStatus } from "@/models/Enums";

export default defineComponent({
  props: {
    firstBtnText: {
      type: String,
    },
    secondBtnText: {
      type: String,
    },
    clubId: {
      type: Number,
      default: 0,
    },
  },
  async setup(props) {
    const { t, locale } = useI18n();
    const store = useStore();
    const defaultBackText = ref(t("cashier.label.back"));
    const defaultCancelText = ref(t("cashier.label.cancel"));
    const orderStatus = computed(() => store.state.order.status);

    if (orderStatus.value) {
      defaultCancelText.value = t("cashier.label.clear-payments");
    }

    watch(locale, () => {
      defaultBackText.value = t("cashier.label.back");
      defaultCancelText.value = t("cashier.label.cancel");
    });
    const router = useRouter();
    const route = useRoute();

    function back() {
      if (route.name == "clubProducts") {
        window.location.reload();
        return;
      }
      if (route.name == "productPriceLines" && props.clubId) {
        router.push({
          name: "clubProducts",
          params: {
            clubId: props.clubId,
          },
        });
        return;
      }
      if (
        route.name == "productPriceLines" ||
        route.name == "productPriceLinesEditMode"
      ) {
        router.push({ name: "select-products" });
        return;
      }
      if (route.name == "select-products") {
        router.push({ name: "home" });
        return;
      }
      router.back();
    }

    async function cancel() {
      if (orderStatus.value) {
        store.dispatch("cancelChanges");
        router.push({
          name: "reservedOrder",
          params: { orderId: store.state.order.id },
        });
        return;
      }
      const result = await swal.fire({
        text: t("cashier.alert.cancel-order"),
        icon: "warning",
        iconColor: "",
        showCancelButton: true,
        cancelButtonText: t("cashier.label.no"),
        confirmButtonText: t("cashier.label.yes"),
        customClass: {
          confirmButton: "popup-bookit-button",
          cancelButton: "close-button-wrapper popup-bookit-button",
        },
        buttonsStyling: false,
      });
      if (result.isConfirmed) {
        if (store.state.order.id) {
          await api.withLoader().SetOrderStatus(store.state.order.id, OrderStatus.CN);
        }
        store.commit("reloadConfirm");
        window.location.reload();
      }
    }
    return { back, cancel, defaultBackText, defaultCancelText };
  },
});
